import { ReactElement } from 'react'
import { GlobalWorkspaceSelectorComponent } from 'app/components/global-workspace-selector/GlobalWorkspaceSelectorComponent'
import { useGlobalWorkspaceSelector } from 'app/components/global-workspace-selector/useGlobalWorkspaceSelector'

/** @deprecated Use GlobalWorkspaceSelectorComponent directly */
export function GlobalWorkspaceSelectorV2(): ReactElement {
  const props = useGlobalWorkspaceSelector()
  return <GlobalWorkspaceSelectorComponent {...props} />
}
